import React from 'react';
import styles from './TextEffectsStriped.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';

export type TextEffectsStripedProps = TextEffectsSharedProps;

const TextEffectsStriped: React.FC<TextEffectsSharedProps> = props => {
  const { text } = props;

  return (
    <TextEffectsShared
      {...props}
      tagProps={{
        className: cx(styles.container, styles.block, styles.text),
        animated: true,
        'data-testid': TestIds.viewer.container,
      }}
    >
      <span data-testid={TestIds.viewer.text} className={styles.block}>
        {text}
      </span>
    </TextEffectsShared>
  );
};

export default TextEffectsStriped;
